import { render, staticRenderFns } from "./HeaderDashboard.vue?vue&type=template&id=19ffbae7&scoped=true&"
import script from "./HeaderDashboard.vue?vue&type=script&lang=ts&"
export * from "./HeaderDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderDashboard.vue?vue&type=style&index=0&id=19ffbae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ffbae7",
  null
  
)

export default component.exports